import React from 'react';

type Props = {
  eyebrow?: string;
  title: React.ReactNode;
  lead?: React.ReactNode;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
  size?: 'md' | 'lg';
  className?: string;
  action?: React.ReactNode;
};

const SectionHeading = ({ eyebrow, title, lead, align = 'left', tone = 'dark', size = 'lg', className = '', action }: Props) => {
  const isLight = tone === 'light';
  const titleSize = size === 'lg' ? 'text-3xl sm:text-4xl lg:text-[2.75rem]' : 'text-2xl sm:text-3xl';
  return (
    <div
      className={`flex flex-col gap-5 ${action ? 'lg:flex-row lg:items-end lg:justify-between' : ''} ${
        align === 'center' ? 'items-center text-center' : ''
      } ${className}`}
    >
      <div className={`max-w-2xl ${align === 'center' ? 'mx-auto' : ''}`}>
        {eyebrow && <span className={`vp-eyebrow ${isLight ? 'vp-eyebrow-light' : ''}`}>{eyebrow}</span>}
        <h2 className={`vp-heading ${eyebrow ? 'mt-4' : ''} ${titleSize} ${isLight ? '!text-white' : ''}`}>{title}</h2>
        {lead && <p className={`mt-4 leading-relaxed ${isLight ? 'text-white/70' : 'text-brand-muted'}`}>{lead}</p>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
};

export default SectionHeading;
